/**
 * Branding Constants
 * 
 * Centralized branding information for consistent use across the application.
 */

/**
 * Primary brand name (for display in UI, titles, meta tags, etc.)
 */
export const BRAND_NAME = 'CarExperts4u';

/**
 * Brand name in Hebrew (for display in UI)
 * @deprecated Use BRAND_NAME instead for consistency
 */
export const BRAND_NAME_HE = BRAND_NAME;

/**
 * Site slogan in Hebrew
 * Note: Uses "מחברים" (plural) to match plural brand name "CarExperts4u"
 */
export const SLOGAN_HE = `${BRAND_NAME} מחברים אתכם למגרשים וסוכנים אמיתיים, עם תהליך שקוף ופשוט.`;

